// 智能柜首页，选择寄存
<template>
  <div class="selectCheck" @click="dblBtn">
    <h1 class="title">极酷智能柜</h1>
    <div class="info">
      <p class="text">箱格剩余数：</p>
      <p class="text">
        <span v-for="(item) in box_list" :key="item.box_size">{{item.box_type}}：{{item.box_num}}</span></p>
    </div>
    <div class="way-list clearfix" @click.stop>
      <div class="way" @click="goSaveSelectWay">存件</div>
      <!-- <router-link :to="{path: '/turnoverCabinet/saveSelectWay'}"  class="way">存件</router-link> -->
      <router-link :to="{path: '/turnoverCabinet/fetchSelectWay'}"  class="way">取件</router-link>
    </div>
    
    <div class="configBtn" v-show="showBtn == true" @click.stop><el-button type="info" @click="toConfig">修改配置</el-button></div>
    <custService></custService>
  </div>
</template>

<script>
import custService from '../../assets/custService'
import { cabinetApi } from "../../../static/turnoverCabinet/js/api.js"
import { showLoading, hideLoading, showToast, storage } from '../../../static/turnoverCabinet/js/utility'

export default {
  name: 'selectCheck',
  components:{
    custService
  },
  data () {
    return {
      box_list: {},
      showBtn:false,
      isSave: false,
      num:0,//点击次数
    }
  },
  created () {
    this.getBoxNum()
    // console.log('type', this.$store.state.type)
  },
  mounted () {
  },
  methods: {
    //连续点击屏幕5次
    dblBtn(){
      var that = this;
      this.num++
      if(this.num==1){
        that.timer1=new Date().getTime()/1000
      }
      if(this.num==5){
        this.timer4= new Date().getTime()/1000
        if(that.timer4-that.timer1<=2){
          that.num=0
          that.showBtn=true
          setTimeout(function(){
            that.showBtn = false
          },5000);
        }else {
          this.num=0
        }
      }
    },
    //跳转到配置页
    toConfig(){
      this.$router.push({
        path:'/CConfigSetting',
        query:{
          'project':true,
        }
      })
    },
    // 去存件
    goSaveSelectWay () {
      console.log('isSave', this.isSave)
      if (!this.isSave) {
        showToast('暂无空闲箱格')
        return
      }
      this.$router.push({
        path:'/turnoverCabinet/saveSelectWay'
      })
    },
    // 获取空闲箱格数量
    async getBoxNum () {
      let vm = this
      let data = {
        device_no_id: storage.localGetItem('device_no_id')
      }
      
      showLoading('获取箱格数量中')
      let res = await cabinetApi.getBoxNum(data)
      hideLoading()
      if (res.meta.code === 200) {
        vm.$store.state.company_id = res.data.company_id
        vm.$store.state.company_ic = res.data.company_ic
        vm.$store.state.server_address = res.data.server_address
        let box_list = res.data.box_list
        for (let i in box_list) {
          let box_size = box_list[i].box_size
          box_list[i].box_type = box_size === 'A' ? '极大' :
                                box_size === 'B' ? '大' :
                                box_size === 'C' ? '中' :
                                box_size === 'D' ? '小' : '极小'
          vm.isSave = box_size != 0 ? true : false
        }
        vm.box_list = box_list
      } else {
        showToast(res.meta.message)
        // 获取箱格失败，重新调用一次api
        setTimeout(function () {
          vm.getBoxNum()
        }, 2000)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .configBtn{
    position: absolute;
    right: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .selectCheck{
    width: 100%;
    color: #ffffff;
    text-align: center;
    position: relative;
    height: 100vh;
  }

  .selectCheck .title{
    font-size: 0.7rem;
    line-height: 0.7rem;
    padding: 1.3rem 0 0.6rem;
  }

  .selectCheck .info {
    width: 7.7rem;
    margin: 0 auto;
    font-size: 0.34rem;
    line-height: 0.5rem;
    border: 1px solid #ffffff;
    border-radius: 0.1rem;
  }

  .selectCheck .info .text:last-child{
    line-height: 1rem;
    border-top: 1px solid #ffffff;
  }

  .selectCheck .info .text span{
    margin-right: 1em;
  }

  .selectCheck .way-list{
    width: 7.8rem;
    margin: 0.9rem auto 1.2rem;
  }

  .selectCheck .way-list .way{
    float: left;
    width: 3.36rem;
    height: 2.38rem;
    line-height: 2.38rem;
    font-size: 0.6rem;
    font-weight: bold;
    color: #ffffff;
    border-radius: 0.1rem;
    background: -webkit-linear-gradient(to top ,#0669be, #4cacff); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(to top,#0669be, #4cacff); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(to top,#0669be, #4cacff); /* Firefox 3.6 - 15 */
    background: linear-gradient(to top,#0669be, #4cacff);
    box-shadow: #2c4b64 0px 0px 0.2rem;
  }

  .selectCheck .way-list .way:last-child{
    float: right;
  }

  .selectCheck .question{
    font-size: 0.5rem;
  }

  .selectCheck .question a{
    color: #0066cc;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/selectCheck.vue